import { PointDetection } from '../schemas/pointDetections';
import { DetectionRequest } from '../schemas/pointDetectionsRequest';
import { wranglerSlice } from '../wranglerSlice';

const pointDetectionEndpoints = wranglerSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPointDetections: builder.query<PointDetection[], DetectionRequest>({
      query: (body: DetectionRequest) => ({
        url: '/v1/point/detections',
        method: 'POST',
        body,
      }),
      providesTags: (_, __, body) => [
        { id: body.data.point_id, type: 'PointDetection' },
      ],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetPointDetectionsQuery } = pointDetectionEndpoints;
